import React from 'react';
import { Prompt } from 'react-router';
import { NavLink } from 'react-router-dom';
import { apiGet, apiPut,apiPost } from '../../../services/apiClient';
import { getCurrentUserCompanyId, getRoles } from '../../../services/userRights';
import ConfirmModal from '../../../modals/confirmModal.jsx';
import AddressTab from './tabs/addressTab.jsx';
import CargoTab from './tabs/cargoTab.jsx';
import CostCalcTab from './tabs/costCalcTab.jsx';
import PayerTab from './tabs/payerTab.jsx';
import CheckBoxInput from '../../../controls/checkBoxInput.jsx';
import Forbidden from '../../forbidden/forbidden.jsx';
import NotFound from '../../notFound/notFound.jsx';

export default class CreateParcelForm extends React.Component {
    constructor(args) {
        super(args);

        this.cargoTab = null;
        this.addressTab = null;
        this.costCalcTab = null;
        this.payerTab = null;

        this.state = {
            busyCount: 0,
            isReady: false,
            lastResponseError: null,
            isComplete: false,
            errors: {},
            parcel: {},
            statuses: [],
            activeTab: "address",
            isInsuranceRequired: false
        };
    }

    componentDidMount() {
        apiGet('parcels/status/all')
            .then(data => {
                this.setState({ statuses: data.entries });
            })
            .catch(e => {});
        apiGet('user/company')
            .then(data => {
                this.setState({isInsuranceRequired: (data || {}).isInsuranceRequired});
                if (!data || (data && data.showNewParcelForm)) {
                    this.props.history.push('/parcels/new3');
                } else {
                    this.prepareCurrentForm();
                }
            })
            .catch(err => this.prepareCurrentForm());
    }

    prepareCurrentForm() {
        this.setState({ isReady: true });
        this.reload();
        $('[data-toggle="popover"]').popover();
    }

    updateBusyCount(inc) {
        this.setState((prevState, props) => {
            prevState.busyCount = prevState.busyCount + inc;
            return prevState;
        });
    }

    reload() {
        let parcel = {
            number: "",
            companyId: getCurrentUserCompanyId()
        };
        this.setState({ parcel: parcel }, () => {
            this.cargoTab.reloadReferences();
            this.addressTab.reloadReferences();
            this.costCalcTab.reloadReferences();
            this.payerTab.reloadReferences();

            this.initParcelData();
        });
    }

    initParcelData() {        
        let parcel = this.state.parcel;
        parcel = this.cargoTab.initParcelData(parcel);
        parcel = this.addressTab.initParcelData(parcel);
        parcel = this.costCalcTab.initParcelData(parcel);
        parcel = this.payerTab.initParcelData(parcel);
        this.setState({ parcel: parcel });
        this.setState({ payerTabVisible: parcel.payerTabVisible });
    }

    getParcelModel() {
        let parcelData = this.cargoTab.fillModel({});
        parcelData = this.addressTab.fillModel(parcelData);
        parcelData = this.costCalcTab.fillModel(parcelData);
        parcelData = this.payerTab.fillModel(parcelData);
        return parcelData;
    }

    save(isReadyToSend, isConfirmed) {
        let errors = null;
        if (isReadyToSend) {
            errors = this.costCalcTab.validateForm();
        }
        if (errors) {
            this.setState({ errors: errors });
        } else {
            this.setState({ errors: {} });
            this.updateBusyCount(1);
            let parcelData = this.getParcelModel();
            parcelData.isReadyToSend = isReadyToSend;
            apiPut('parcels/new', parcelData)
                .then(data => {
                    this.processSaveResult(data);
                })
                .catch(errors => {
                    this.updateBusyCount(-1);
                    this.setState({ errors: errors && errors.validationResult && errors.validationResult.messages });
                });
        }
    }

    processSaveResult(data) {
        if (data.needConfirmation) {
            this.confirmModal.open('Создание посылки', data.confirmationMessage)
                .then(() => {
                    let statusSend = this.state.statuses.find(item => item.name === "Отправлена ТК");
                    apiPost('parcels/' + data.parcelId + '/status/' + statusSend.id + '/confirmed')
                        .then(dataState => {
                              this.processSaveResult(dataState); 
                        })
                        .catch(err => {
                            this.updateBusyCount(-1);
                            if (err.messages) {
                                this.setState({ errors: err.messages });
                                this.infoModal.open(title, 'Не соблюдены условия для смены статуса посылки');
                            }
                        });
                })
                .catch(() => {
                    this.openForm(data.parcelId);
                });
        } else {
            this.openForm(data.parcelId);
        }
    }

    openForm(id) {
        this.setState(
            {
                isComplete: true
            },
            () => {
                this.props.history.push({
                    pathname: '/parcels/' + id,
                    state: { isNew: true }
                });
            }
        );
    }

    backToList() {
        this.props.history.push('/parcels/list');
    }

    openTab(tabName) {
        this.setState({ activeTab: tabName });
    }

    moveToCargoTab() {
        let errors = this.addressTab.validateForm();
        if (errors) {
            this.setState({ errors: errors });
        } else {
            this.setState({ errors: {} });
            this.openTab("cargo");
        }
    }

    moveToPayerTab() {
        let errors = this.cargoTab.validateForm();
        if (errors) {
            this.setState({ errors: errors });
        } else {
            this.setState({ errors: {} });
            if (this.state.parcel.payerTabVisible)
                this.openTab("payer");
            else
                this.openTab("costCalc");
        }
    }

    moveToCostCalcTab(refTab) {
        let errors = refTab.validateForm();
        if (errors) {
            this.setState({ errors: errors });
        } else {
            this.setState({ errors: {} });
            this.openTab("costCalc");
        }
    }

    handleFieldChange(newFieldValues) {
        let promise = new Promise((resolve, reject) => {
            let parcel = this.state.parcel;
            let errors = this.state.errors;
            newFieldValues.map((field, ind, arr) => {
                parcel[field.name] = field.value;
                errors[field.name] = null;
            });
            this.setState(
                {
                    parcel: parcel,
                    errors: errors
                },
                () => resolve()
            );
        });
        return promise;
    }

    handleInputChange(name, newValue) {
        let fields = [{
            name: name,
            value: newValue
        }];
        return this.handleFieldChange(fields);
    }

    clearErrors() {
        this.setState({ errors: {} });
    }

    renderBusyOverlay(isBusy) {
        return isBusy
            ? <div className="overlay">
                <i className="fa fa-refresh fa-spin"></i>
            </div>
            : null;
    }

    render() {
        let roles = getRoles();
        let hasAccess = roles.includes('Author') || roles.includes('Coordinator');
        if (!hasAccess || this.state.lastResponseError === 403) {
            return <Forbidden />;
        }
        if (this.state.lastResponseError === 404) {
            return <NotFound />;
        }

        if (!this.state.isReady) {
            return null;
        }

        let hasAddressErrors = this.addressTab ? this.addressTab.hasFormErrors(this.state.errors) : false;
        let hasCargoErrors = this.cargoTab ? this.cargoTab.hasFormErrors(this.state.errors) : false;
        let hasCostCalcErrors = this.costCalcTab ? this.costCalcTab.hasFormErrors(this.state.errors) : false;
        let hasPayerErrors = this.payerTab ? this.payerTab.hasFormErrors(this.state.errors) : false;

        let addressTabClass = (this.state.activeTab === "address" ? "active " : "") + (hasAddressErrors ? "has-error " : "");
        let cargoTabClass = (this.state.activeTab === "cargo" ? "active " : "") + (hasCargoErrors ? "has-error " : "");
        let costCalcTabClass = (this.state.activeTab === "costCalc" ? "active " : "") + (hasCostCalcErrors ? "has-error " : "");
        let payerTabClass = (this.state.activeTab === "payer" ? "active " : "") + (hasPayerErrors ? "has-error " : "");

        let isBusy = this.state.busyCount > 0;
        return (
            <div className='old-design'>
                <section className="content-header">
                    <h1>Новая посылка</h1>
                    <ol className="breadcrumb">
                        <li><NavLink to="/parcels/list"><i className="fa fa-inbox"></i>Посылки</NavLink></li>
                        <li className="active">Новая посылка</li>
                    </ol>
                </section>

                <section className="content">
                    <div className="row">
                        <div className="col-xs-12 col-lg-10 col-lg-offset-1">
                            <div className="nav-tabs-custom overlay-wrapper form-overlay-wrapper tab-form-overlay-wrapper">
                                {this.renderBusyOverlay(isBusy)}

                                <ul className="nav nav-tabs">
                                    <li className={addressTabClass}>
                                        <a>Адрес</a>
                                    </li>
                                    <li className={cargoTabClass}>
                                        <a onClick={() => { console.error(this.state.errors) }}>Посылка</a>
                                    </li>
                                    {this.state.parcel.payerTabVisible &&
                                        <li className={payerTabClass}>
                                            <a onClick={() => { console.error(this.state.errors) }}>Плательщик</a>
                                        </li>
                                    }
                                    <li className={costCalcTabClass}>
                                        <a>Расчет стоимости</a>
                                    </li>
                                </ul>

                                <div className="tab-content">
                                    <div className={"tab-pane" + (this.state.activeTab === "address" ? " active" : "")}>
                                        <AddressTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew
                                            isBusy={isBusy}
                                            ref={tab => this.addressTab = tab}
                                            onFieldChange={values => this.handleFieldChange(values)}
                                        />

                                        <div className="box-footer">
                                            <button className="btn btn-flat btn-default btn-tool" onClick={() => this.backToList()} disabled={isBusy}>
                                                <i className="glyphicon glyphicon-ban-circle"></i> Отмена
                                            </button>
                                            <button className="btn btn-flat btn-primary pull-right" onClick={() => this.moveToCargoTab()} disabled={isBusy}>
                                                Далее <i className="fa fa-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "cargo" ? " active" : "")}>
                                        <CargoTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew
                                            isBusy={isBusy}
                                            ref={tab => this.cargoTab = tab}
                                            onFieldChange={values => this.handleFieldChange(values)}
                                            isInsuranceRequired={this.state.isInsuranceRequired}
                                        />

                                        <div className="box-footer">
                                            <button className="btn btn-flat btn-default btn-tool" onClick={() => this.backToList()} disabled={isBusy}>
                                                <i className="glyphicon glyphicon-ban-circle"></i> Отмена
                                            </button>
                                            <button className="btn btn-flat btn-default" onClick={() => this.openTab("address")} disabled={isBusy}>
                                                <i className="fa fa-arrow-left"></i> Назад
                                            </button>
                                            <button className="btn btn-flat btn-primary pull-right" onClick={() => {
                                                if (this.state.parcel.payerTabVisible) {
	                                                this.moveToPayerTab();
                                                } else {
	                                                this.moveToCostCalcTab(this.cargoTab);
                                                }
                                            }} disabled={isBusy}>
                                                Далее <i className="fa fa-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "payer" ? " active" : "")}>
                                        <PayerTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew
                                            isBusy={isBusy}
                                            ref={tab => this.payerTab = tab}
                                            onFieldChange={values => this.handleFieldChange(values)}
                                        />

                                        <div className="box-footer">
                                            <button className="btn btn-flat btn-default btn-tool" onClick={() => this.backToList()} disabled={isBusy}>
                                                <i className="glyphicon glyphicon-ban-circle"></i> Отмена
                                            </button>
                                            <button className="btn btn-flat btn-default" onClick={() => this.openTab("cargo")} disabled={isBusy}>
                                                <i className="fa fa-arrow-left"></i> Назад
                                            </button>
                                            <button className="btn btn-flat btn-primary pull-right"
                                                    onClick={() => this.moveToCostCalcTab(this.payerTab)}
                                                disabled={isBusy}
                                            >
                                                Далее <i className="fa fa-arrow-right"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className={"tab-pane" + (this.state.activeTab === "costCalc" ? " active" : "")}>
                                        <CostCalcTab parcel={this.state.parcel}
                                            errors={this.state.errors}
                                            isNew
                                            isBusy={isBusy}
                                            ref={tab => this.costCalcTab = tab}
                                            getParcelModel={() => this.getParcelModel()}
                                            clearErrors={() => this.clearErrors()}
                                            onFieldChange={values => this.handleFieldChange(values)}
                                        />

                                        <div className="box-footer">
                                            <div>
                                                <button className="btn btn-flat btn-default btn-tool" onClick={() => this.backToList()} disabled={isBusy}>
                                                    <i className="glyphicon glyphicon-ban-circle"></i> Отмена
                                                </button>
                                                <button className="btn btn-flat btn-default" onClick={() => {
                                                    if (this.state.parcel.payerTabVisible) {
	                                                    this.openTab("payer");
                                                    } else {
                                                        this.openTab("cargo");
                                                    }
                                                }
                                                } disabled={isBusy}>
                                                    <i className="fa fa-arrow-left"></i> Назад
                                                </button>
                                                <button className="btn btn-flat btn-primary pull-right" onClick={() => this.save(true, false)} disabled={isBusy}>
                                                    <i className="glyphicon glyphicon-send"></i> Заказать отправку
											    </button>
                                                <button className="btn btn-flat btn-primary btn-tool pull-right" onClick={() => this.save(false, false)} disabled={isBusy}>
                                                    <i className="glyphicon glyphicon-floppy-disk"></i> Сохранить для доработки
                                                </button>
                                            </div>
                                            <div className="form-group offer-checkbox pull-right">
                                                Нажимая кнопку «Заказать отправку», я соглашаюсь с условиями публичной оферты, работы курьерских служб и даю согласие на обработку персональных данных
                                            </div>
                                            <div className="checkbox offer-checkbox">
                                                <label>
                                                    <CheckBoxInput id="inputAllStatusNotifications"
                                                        title={this.state.errors.allStatusNotifications}
                                                        checked={this.state.parcel.allStatusNotifications}
                                                        onChange={e => this.handleInputChange("allStatusNotifications", e)}
                                                        disabled={isBusy}
                                                    />
                                                    Хочу отслеживать отправление
                                                </label>
                                                <a tabIndex="0" role="button" data-toggle="popover" data-trigger="hover" title="Хочу отслеживать отправление"
                                                    data-content="При выборе данной опции Вам на почту будут отправляться уведомления о изменении статуса посылки">
                                                    <span className="glyphicon glyphicon-question-sign text-blue control-help-btn"></span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <Prompt when={!this.state.isComplete}
                    message="Вы действительно хотите отменить создание новой посылки? Введенная вами информация не будет сохранена."
                />
                <ConfirmModal ref={modal => this.confirmModal = modal} />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/pages/parcels/form/createParcelForm.jsx